import { getLexileReport, getTestDuration, formatLexileMeasure } from './lexileReportData';

const testTypes = {
  1: '1 · BR–10L', 4: '2 · 10–100L', 6: '3 · 100–250L',
  8: '4 · 250–550L', 10: '5 · 550–900L', 13: '6 · 900–1500L',
};
export const formatAssignedTest = (value) => testTypes[value] ? `Test ${testTypes[value]}` : value ? `Test ${value}` : 'Not assigned';
export const formatTestDuration = (minutes) => minutes == null ? 'Not available' : minutes >= 1440
  ? `${Math.floor(minutes / 1440)}d ${Math.floor(minutes % 1440 / 60)}h`
  : minutes >= 60 ? `${Math.floor(minutes / 60)}h ${minutes % 60}m` : `${minutes} min`;

export const getTestAccuracy = (test) => {
  const answers = test?.user_levelup_test_answers || [];
  if (!answers.length) return { correct: null, total: null, percentage: null };
  const correct = answers.filter((answer) => answer?.is_correct === true).length;
  return { correct, total: answers.length, percentage: Math.round(correct / answers.length * 100) };
};

export function getStudentTestMetrics(user = {}) {
  user = user || {};
  const tests = [...(user.user_levelup_tests || [])]
    .filter((test) => test && (!test.type || test.type === 'leveltest'))
    .sort((a, b) => (Date.parse(b.test_end_date || b.test_date) || 0) - (Date.parse(a.test_end_date || a.test_date) || 0) || Number(b.idx) - Number(a.idx));
  const completed = tests.filter((test) => String(test.stat) === '2');
  const latest = completed[0];
  const current = getLexileReport(user.lexile_level) || getLexileReport(latest?.lexile);
  const accuracy = getTestAccuracy(latest);
  return {
    tests, completed, latest, current, accuracy,
    inProgress: tests.filter((test) => String(test.stat) === '1').length,
    duration: getTestDuration(latest),
    history: tests.map((test, index) => {
      const result = String(test.stat) === '2' ? getLexileReport(test.lexile) : null;
      return {
        ...test, attempt: tests.length - index,
        status: String(test.stat) === '2' ? 'Completed' : String(test.stat) === '1' ? 'In Progress' : 'Not Started',
        measure: result ? formatLexileMeasure(result.score) : '—',
        levelName: result ? `Level ${result.current.level} · ${result.current.name}` : '—',
        duration: String(test.stat) === '2' ? formatTestDuration(getTestDuration(test)) : '—',
      };
    }),
  };
}
